import React from 'react';
import {Button} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {useFileContext} from 'context/FileContext';
import {encryptAndUpload} from './upload/encryptAndUpload';
import {useAuthContext} from 'context/AuthContext';
// import {API_SERVER} from 'const';
// import axios from 'axios';

const UploadFiles: React.FC = () => {
   const {
      authData: {enforcePgp},
   } = useAuthContext();
   const {publicArmoredKey, refetchFolder, currentFolder} = useFileContext();

   const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
      const files = event.target.files;
      if (!files) return;

      Array.from(files).forEach((file) => {
         encryptAndUpload(file, publicArmoredKey, refetchFolder, currentFolder!.path, enforcePgp);
         // uploadFileStream(file, publicArmoredKey, refetchFolder);
      });
   };

   return (
      <Button variant="contained" color="success" component="label" startIcon={<CloudUploadIcon />}>
         Upload
         <input type="file" hidden multiple onChange={handleFileUpload} />
      </Button>
   );
};

export default UploadFiles;
